import * as angular from "angular";
import {IController} from "angular";

export class NumericWidgetComponent implements IController {

  value: number;
  color: string;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('numericWidget', {
    bindings: {
      value: '<',
      name: '<',
      color: '<'
    },
    template: require('./numeric-widget.html').default,
    controller: NumericWidgetComponent
  });
